import { useEffect, useState } from "react";

const ScrollToTopButton = ({ tooltip = "Ir arriba" }) => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const toggleVisibility = () => {
      setVisible(window.scrollY > 200);
    };

    window.addEventListener("scroll", toggleVisibility);
    return () => window.removeEventListener("scroll", toggleVisibility);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <>
      <div className={`scroll-top-wrapper ${visible ? "visible" : ""}`}>
        <button
          className="scroll-top-btn"
          onClick={scrollToTop}
          aria-label={tooltip}
          title={tooltip}
        >
          <i className="fas fa-arrow-up"></i>
        </button>
      </div>

      <style>{`
        .scroll-top-wrapper {
          position: fixed;
          bottom: 30px;
          right: 20px;
          z-index: 1000;
          opacity: 0;
          transform: translateY(40px) scale(0.8);
          transition: opacity 0.4s ease, transform 0.4s ease;
          pointer-events: none;
        }
        .scroll-top-wrapper.visible {
          opacity: 1;
          transform: translateY(0) scale(1);
          pointer-events: auto;
        }
        .scroll-top-btn {
          width: 40px;
          height: 40px;
          border-radius: 50%;
          background-color: #007bff;
          color: white;
          font-size: 20px;
          box-shadow: 0 4px 8px rgba(0,0,0,0.3);
          display: flex;
          justify-content: center;
          align-items: center;
          cursor: pointer;
          transition: transform 0.3s ease, opacity 0.3s ease;
        }
        .scroll-top-btn:hover {
          transform: scale(1.1);
          opacity: 0.9;
        }
      `}</style>
    </>
  );
};

export default ScrollToTopButton;